<template>
  <div :title="$t('sectionModalSearch.clickToSearchMessagesContact')">
    <button
      type="button"
      class="btn-square btn-secondary btn-rounded"
      @click="AbrirModal()"
    >
      <i class="fas fa-search"></i>
    </button>

    <b-modal
      v-model="abrir"
      :title="$t('sectionModalSearch.searchMessagesContact')"
      size="lg"
      hide-footer
    >
      <div class="input-group mb-3">
        <input
          v-model="termo"
          type="text"
          class="form-control"
          :placeholder="$t('sectionModalSearch.typeToSearch')"
          aria-label="Recipient's username"
          aria-describedby="button-addon4"
        />
        <div class="input-group-append">
          <button
            id="button-addon4"
            class="btn btn-primary"
            type="button"
            @click="Pesquisar()"
          >
            <i class="fas fa-search" />
          </button>
        </div>
      </div>
      <div v-if="loading" class="loading-container">
        <RotateSquare
          class="loading-position animated fadeIn"
          size="60px"
        ></RotateSquare>
      </div>
      <div v-else>
        <b-table
          :hover="true"
          responsive
          :items="itens"
          :fields="fields"
          striped
          :per-page="itensPorPagina"
          show-empty
          :empty-text="$t('sectionModalSearch.notMessageFound')"
        >
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template v-slot:cell(data)="data">
            <div class="center">
              <label for>{{ new Date(data.item.data).toLocaleString() }}</label>
            </div>
          </template>
          <template v-slot:cell(origem)="data">
            <div class="center">
              <label for>{{ ObterNomeOrigem(data.item.origem) }}</label>
            </div>
          </template>
        </b-table>
        <b-pagination
          v-model="pagina"
          :total-rows="total"
          :per-page="itensPorPagina"
          align="right"
          size="md"
          class="mt-2"
        ></b-pagination>
      </div>
    </b-modal>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import OrigemMensagem from "../../enums/OrigemMensagem";

export default {
  name: "ModalSearch",
  components: {
    RotateSquare
  },
  props: {
    contatoId: {
      type: String,
      default: ""
    },
    telefoneId: {
      type: String,
      default: ""
    },
    enumTipoContato:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      termo: "",
      loading: false,
      abrir: false,
      itens: [],
      pagina: 1,
      total: 0,
      itensPorPagina: 5
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "data",
          label: this.$t("sectionEmail.emailData"),
          sortable: true
        },
        {
          key: "nome",
          label: this.$t("sectionOrcamento.orcamentoNome"),
          sortable: true
        },
        {
          key: "corpo",
          label: this.$t("sectionUsuario.usuarioTexto"),
          sortable: true
        },
        {
          key: "origem",
          label: this.$t("sectionOrcamento.orcamentoOrigem"),
          sortable: true
        }
      ];
    }
  },
  watch: {
    pagina: function (val) {
      this.ObterGrid(val);
    }
  },
  methods: {
    ObterNomeOrigem(origem) {
      switch (origem) {
        case OrigemMensagem.Recebida:
          return this.$t("sectionModalSearch.received");
        case OrigemMensagem.Enviada:
          return this.$t("sectionModalSearch.sent");
        default:
          return this.$t("textNenhum");
      }
    },
    Pesquisar() {
      this.ObterGrid(1);
    },
    AbrirModal() {
      this.abrir = true;
      this.termo = "";
      this.itens = [];
      this.pagina = 1;
      this.total = 0;
    },
    ObterGrid(pagina) {
      this.loading = true;
      this.$http({
        url:
          "mensagem-front/obter?ContaId=" +
          this.$store.getters.getAutenticacao.contaSelecionadaId +
          "&TelefoneId=" +
          this.telefoneId +
          "&ContatoId=" +
          this.contatoId +
          "&Pagina=" +
          pagina +
          "&ItensPorPagina=" +
          this.itensPorPagina +
          "&Texto=" +
          this.termo +
          "&TipoConversa=" +
          this.enumTipoContato,
        method: "GET"
      })
        .then((response) => {
          this.loading = false;
          this.itens = response.data.itens;
          this.total = response.data.total;
          this.pagina = response.data.pagina;
          this.itensPorPagina = response.data.itensPorPagina;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>

<style lang="scss"></style>
